import script from "./NavbarLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarLayout.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarLayout.vue?vue&type=style&index=0&id=85e3cbb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e3cbb2"]])

export default __exports__